import { useApiMutation } from "@/shared/lib/hooks/api";
import { API_URL } from "@/shared/config";
import { TbArrowDownLeft } from "react-icons/tb";

interface IExportButton {
  url: string;
  fileName?: string;
  method?: "get" | "post";
  body?: any;
}

interface ExportResponse {
  downloadUrl: string;
}

export const downlaodFileByName = async ({
  fileUrl,
  fileName,
}: {
  fileUrl: unknown;
  fileName: string;
}) => {
  try {
    const response = await fetch(API_URL + "/" + fileUrl);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("File download error:", error);
  }
};

const ExportButton = ({ url, fileName, method = "get", body }: IExportButton) => {
  const { mutate, status } = useApiMutation<{}, ExportResponse>(url, method, {
    onSuccess(data) {
      if (data?.data) {
        downlaodFileByName({
          fileUrl: data.data as unknown,
          fileName: fileName || "export",
        });
      }
    },
  });

  return (
    <button
      className="action-button"
      onClick={() => mutate(body || {})}
      disabled={status === "pending"}
    >
      <TbArrowDownLeft className="button-icon" />
      <span>{status === "pending" ? "Exporting..." : "Export"}</span>
    </button>
  );
};

export default ExportButton;
